import Redactor from './Redactor';

export default Redactor;
